import { render, staticRenderFns } from "./HistoryItem.vue?vue&type=template&id=6b5fb05a&scoped=true"
import script from "./HistoryItem.vue?vue&type=script&lang=js"
export * from "./HistoryItem.vue?vue&type=script&lang=js"
import style0 from "./HistoryItem.vue?vue&type=style&index=0&id=6b5fb05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5fb05a",
  null
  
)

export default component.exports